import React from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid';
import _isEmpty from 'lodash/isEmpty';
import ReviewsPeriodInsight from '@app/model/review/digest/ReviewsPeriodInsight';

const stripSentimentIndicator = (text: string) => {
	return text.replace(/^\s*(?:[\u2191\u2193\u2197\u2198\u2B06\u2B07\u25B2\u25BC]\uFE0F?\s*)+/, '').trim();
};

const ReviewsCompetitorInsightsKeyObservations: React.FunctionComponent<{positiveInsights: ReviewsPeriodInsight[], negativeInsights: ReviewsPeriodInsight[]}> = ({positiveInsights, negativeInsights}) => {

	return <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm px-4 py-3 sm:px-5 sm:py-4">
		{!_isEmpty(positiveInsights) && <div>
			<div className="mb-3 flex items-center gap-2 px-1">
				<span className="h-2 w-2 rounded-full bg-green-500" />
				<h3 className="text-xs font-bold uppercase tracking-wide text-gray-600">What's Working</h3>
				<span className="text-xs text-gray-400">({positiveInsights.length})</span>
			</div>
			<div className="space-y-3">
				{positiveInsights.map((insight, index) => <div
					key={`positive-insight-${index}`}
					className="rounded-md bg-green-50 border border-green-300 p-3 pb-2">
					<div className="flex">
						<div className="shrink-0">
							<ArrowUpIcon className="w-4 h-4 text-green-600 relative top-0.5" />
						</div>
						<div className="ml-2 relative w-full -top-0.5">
							<p className="text-sm font-bold text-gray-700">
								{stripSentimentIndicator(insight.insight.title)}
							</p>
							<p className="text-xs font-light tracking-tight text-gray-500">
								{stripSentimentIndicator(insight.insight.body)}
							</p>
						</div>
					</div>
				</div>)}
			</div>
		</div>}
		{!_isEmpty(negativeInsights) && !_isEmpty(positiveInsights) && <div className="flex items-center my-3">
			<div aria-hidden="true" className="w-full border-t border-gray-300" />
			<div className="relative flex justify-center">
				<span className="bg-white px-2 text-sm text-gray-500">vs.</span>
			</div>
			<div aria-hidden="true" className="w-full border-t border-gray-300" />
		</div>}
		{!_isEmpty(negativeInsights) && <div>
			<div className="mb-3 flex items-center gap-2 px-1">
				<span className="h-2 w-2 rounded-full bg-red-500" />
				<h3 className="text-xs font-bold uppercase tracking-wide text-gray-600">Needs Attention</h3>
				<span className="text-xs text-gray-400">({negativeInsights.length})</span>
			</div>
			<div className="space-y-3">
				{negativeInsights.map((insight, index) => <div
					key={`negative-insight-${index}`}
					className="rounded-md bg-red-50 border border-red-300 p-3 pb-2">
					<div className="flex">
						<div className="shrink-0">
							<ArrowDownIcon className="w-4 h-4 text-red-600 relative top-0.5" />
						</div>
						<div className="ml-2 relative w-full -top-0.5">
							<p className="text-sm font-bold text-gray-700">
								{stripSentimentIndicator(insight.insight.title)}
							</p>
							<p className="text-xs font-light tracking-tight text-gray-500">
								{stripSentimentIndicator(insight.insight.body)}
							</p>
						</div>
					</div>
				</div>)}
			</div>
		</div>}
	</div>
}

export default ReviewsCompetitorInsightsKeyObservations;
